"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../services");
var types_1 = require("../../types");
var getBackLink_1 = __importDefault(require("./getBackLink"));
var isInnerPage_1 = __importDefault(require("./isInnerPage"));
function goBack() {
    var previousLocation = window.__app.previousLocation;
    var history = services_1.getHistory();
    if (previousLocation &&
        !isInnerPage_1.default(previousLocation.pathname, [types_1.App.Routes.TOURNAMENT])) {
        return history.goBack();
    }
    var backLink = getBackLink_1.default();
    if (backLink) {
        history.push(backLink.link);
    }
}
exports.default = goBack;
//# sourceMappingURL=goBack.js.map